import { gql } from '@apollo/client';

import { CreateOfferFragment } from 'buying/graphql/fragments/CreateOfferFragment';

export const UpdateOfferFinancing = gql`
  mutation UpdateOfferFinancing(
    $mortgagePreapproval: Boolean!
    $fundingSource: OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferFinancing_FundingSource!
    $offerId: String
  ) {
    buyer {
      updateOfferFinancing(
        input: {
          mortgagePreapproval: $mortgagePreapproval
          fundingSource: $fundingSource
          id: $offerId
        }
      ) {
        offer {
          ...CreateOfferFragment
        }
      }
    }
  }
  ${CreateOfferFragment}
`;
